import { type DynamicResource, notifyDynamicResourceLoad } from '#i18n/LazyResourceBackend'

if (import.meta.hot) {
  import.meta.hot.accept('./de/shared.json', (module) => notifyDynamicResourceLoad('de', 'shared', module))
  import.meta.hot.accept('./dev/shared.json', (module) => notifyDynamicResourceLoad('dev', 'shared', module))
  import.meta.hot.accept('./en/shared.json', (module) => notifyDynamicResourceLoad('en', 'shared', module))
  import.meta.hot.accept('./it/shared.json', (module) => notifyDynamicResourceLoad('it', 'shared', module))
}

export const sharedResources = {
  de: {
    shared: () => import('./de/shared.json'),
  },
  dev: {
    shared: () => import('./dev/shared.json'),
  },
  en: {
    shared: () => import('./en/shared.json'),
  },
  it: {
    shared: () => import('./it/shared.json'),
  },
} as const satisfies DynamicResource
